import { DateTime } from "luxon";

export const dateTimeNowForExcel = () => new Date().toISOString().replace("T", " ").split(".")[0];

export function costModelLabel(costModel: { name?: string | null; created_at?: string }): string {
  const name = costModel.name?.trim();
  if (name) return name;
  const created = costModel.created_at ? DateTime.fromISO(costModel.created_at) : null;
  return created?.isValid ? `Untitled Cost Model — ${created.toFormat("LLL d, yyyy")}` : "Untitled Cost Model";
}
